<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 21.6c2.5461 0 4.9879-1.0114 6.7882-2.8118C20.5886 16.9879 21.6 14.5461 21.6 12c0-2.54608-1.0114-4.98787-2.8118-6.78822C16.9879 3.41143 14.5461 2.4 12 2.4c-2.54605 0-4.98785 1.01143-6.7882 2.81178C3.41145 7.01213 2.40002 9.45392 2.40002 12c0 2.5461 1.01143 4.9879 2.81178 6.7882C7.01215 20.5886 9.45395 21.6 12 21.6Zm4.4484-11.1516c.2186-.2263.3396-.52944.3368-.84408-.0027-.31464-.1289-.61561-.3514-.8381-.2225-.22249-.5235-.34869-.8381-.35143-.3146-.00273-.6178.11822-.8441.33681L10.8 12.7032l-1.55158-1.5516c-.22632-.2186-.52944-.3395-.84408-.3368-.31463.0027-.61561.1289-.8381.3514-.22249.2225-.34869.5235-.35142.8381-.00274.3147.11821.6178.3368.8441l2.4 2.4c.22508.225.53018.3513.84838.3513.3182 0 .6234-.1263.8484-.3513l4.8-4.8Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 4c-2.12173 0-4.15656.84285-5.65685 2.34315C4.84285 7.84344 4 9.87827 4 12c0 1.0506.20693 2.0909.60896 3.0615.40204.9706.99132 1.8525 1.73419 2.5954.74286.7428 1.62478 1.3321 2.59538 1.7341C9.90914 19.7931 10.9494 20 12 20c1.0506 0 2.0909-.2069 3.0615-.609.9706-.402 1.8525-.9913 2.5954-1.7341.7428-.7429 1.3321-1.6248 1.7341-2.5954.4021-.9706.609-2.0109.609-3.0615 0-2.12173-.8429-4.15656-2.3431-5.65685C16.1566 4.84285 14.1217 4 12 4Zm-7.07107.92893C6.8043 3.05357 9.34784 2 12 2c2.6522 0 5.1957 1.05357 7.0711 2.92893C20.9464 6.8043 22 9.34784 22 12c0 1.3132-.2587 2.6136-.7612 3.8268-.5026 1.2133-1.2391 2.3157-2.1677 3.2443-.9286.9286-2.031 1.6651-3.2443 2.1677C14.6136 21.7413 13.3132 22 12 22c-1.3132 0-2.61358-.2587-3.82683-.7612-1.21326-.5026-2.31565-1.2391-3.24424-2.1677-.92858-.9286-1.66518-2.031-2.16773-3.2443C2.25866 14.6136 2 13.3132 2 12c0-2.65216 1.05357-5.1957 2.92893-7.07107ZM15.7071 9.29289c.3905.39053.3905 1.02371 0 1.41421l-4 4c-.3905.3905-1.0237.3905-1.4142 0l-2.00001-2c-.39052-.3905-.39052-1.0237 0-1.4142.39053-.3905 1.02369-.3905 1.41422 0L11 12.5858l3.2929-3.29291c.3905-.39052 1.0237-.39052 1.4142 0Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
